import * as Sentry from '@sentry/react';

const backendUrl = import.meta.env.VITE_BACKEND_URL;
const tracePropagationTargets = ['localhost'];

if (backendUrl) {
  try {
    tracePropagationTargets.push(new URL(backendUrl).origin);
  } catch {
    tracePropagationTargets.push(backendUrl);
  }
}

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  dataCollection: {
    // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#dataCollection
    // userInfo: false,
    // httpBodies: [],
  },
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
});
